export class PolicyTypeDisplayNameConstants {
  static readonly UNASSOCIATED = 'Other';
  static readonly AUTO = 'Auto';
  static readonly HOME = 'Homeowners';
  static readonly LIFE = 'Life';
  static readonly MIXED = 'Mixed';
  static readonly OTHER = 'Other';
  static readonly UMBRELLA = 'Umbrella';
}
